import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "mb-2" };
const _hoisted_2 = { class: "section-label text-muted" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_5 = { class: "section-label text-muted" };
const _hoisted_6 = {
    key: 1,
    class: "mb-2"
};
const _hoisted_7 = { class: "section-label text-muted" };
const _hoisted_8 = {
    key: 2,
    class: "mb-2"
};
const _hoisted_9 = { class: "section-label text-muted" };
const _hoisted_10 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_11 = ["href"];
const _hoisted_12 = { key: 1 };
const _hoisted_13 = {
    key: 3,
    class: "mb-2"
};
const _hoisted_14 = { class: "section-label text-muted" };
import AppShowCountry from "@AppShows/AppShowCountry.vue";
import { usePrizeMoneyPayoutContactHelpers } from "./prize_money_payout";
import { prependApiDomain } from "@/utils/prependApiDomain";
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: "PrizeMoneyPayoutContactMasterlist"
    },
    __name: 'PrizeMoneyPayoutContactMasterlist',
    props: {
        contact: { default: () => null },
        prizeMoneyPayout: {},
        smallerLabels: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const { iban, showMainDetails, code, name, addressContactFormat, showAdditionals } = usePrizeMoneyPayoutContactHelpers(props);
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({
                    'smaller-labels': _ctx.smallerLabels
                })
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createTextVNode(_toDisplayString(_ctx.$t("events:event.masterlist.RegOtherInfo.prizeMoneyPayoutMethodSelection.heading", "Prize money is requested to:")) + " ", 1),
                        (_ctx.prizeMoneyPayout.method == 'BANK_TRANSFER')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("events:event.masterlist.RegOtherInfo.prizeMoneyPayoutMethodSelection.bankAccount.text", "bank account")), 1)
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("events:event.masterlist.RegOtherInfo.prizeMoneyPayoutMethodSelection.sportsFund.text", "sports fund")) + " (" + _toDisplayString(_ctx.prizeMoneyPayout.sportFundAthleteId) + ") ", 1)
                            ], 64))
                    ])
                ]),
                (_ctx.contact && _ctx.prizeMoneyPayout.method == 'BANK_TRANSFER')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_unref(showMainDetails))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("events:event.masterlist.RegOtherInfo.prizeMoneyReceiverName.subheading", "Name of prize money receiver")), 1),
                                _createTextVNode(" " + _toDisplayString(_unref(name)) + " " + _toDisplayString(_unref(code)) + " ", 1),
                                _createVNode(AppShowCountry, {
                                    country: _ctx.contact.registryCountry
                                }, null, 8, ["country"])
                            ]))
                            : _createCommentVNode("", true),
                        (_unref(iban))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("events:event.masterlist.RegOtherInfo.prizeMoneyReceiverIban.subheading", "IBAN / Account number")), 1),
                                _createTextVNode(" " + _toDisplayString(_unref(iban)), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (_unref(showAdditionals))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("events:event.masterlist.RegOtherInfo.additionalDetailsPrizeMoney.subheading", "Additional details")), 1),
                                (_ctx.contact.incomeTaxPercentage != null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("events:prizeMoneyReceiver.component.additionalDetails.currentIncomeTaxRate.label", "Current income tax rate:")) + " " + _toDisplayString(_ctx.contact.incomeTaxPercentage + "%"), 1),
                                        (_ctx.contact.incomeTaxCardExpirationDate)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" (... " + _toDisplayString(_ctx.$dayjs.date(_ctx.contact.incomeTaxCardExpirationDate)) + ") ", 1)
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", null, [
                                    (_ctx.contact.incomeTaxCardFilePath)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: _unref(prependApiDomain)(_ctx.contact.incomeTaxCardFilePath),
                                            target: "_blank"
                                        }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("events:prizeMoneyReceiver.component.additionalDetails.taxCard.label", "Tax card:")) + " ", 1),
                                            _createVNode(_component_v_icon, { small: "" }, {
                                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                                        _createTextVNode("$iconPage", -1)
                                                    ]))]),
                                                _: 1
                                            })
                                        ], 8, _hoisted_11))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("events:prizeMoneyReceiver.component.additionalDetails.taxCard.label", "Tax card:")) + " " + _toDisplayString(_ctx.$t("events:prizeMoneyReceiver.component.additionalDetails.taxCardNotProvided.text", "not provided")), 1))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_unref(addressContactFormat))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("events:event.masterlist.RegOtherInfo.addressPrizeMoneyReceiver.subheading", "Address of prize money receiver")), 1),
                                _createTextVNode(" " + _toDisplayString(_unref(addressContactFormat)), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
